var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('fade-loader',{attrs:{"loading":_vm.loading,"color":"lightgrey"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }